export function roundToScale<T extends number|null|undefined>(value: T, scale: number) {
  if (typeof value === 'number') {
    return Math.round(value * (10 ** scale)) / (10 ** scale)
  }

  return value
}
